import "../styles/pages.scss";
import w1 from "../assets/img/w1.png";
import w2 from "../assets/img/w2.png";
import w3 from "../assets/img/w3.png";
import w4 from "../assets/img/w4.png";
import scroll from "../assets/img/Scroll.png";
import info from "../assets/img/info.png";
import price from "../assets/img/price.png";
import cal from "../assets/img/cal.png";
import picture from "../assets/img/picture.png";
import location from "../assets/img/location.png";
import { useEffect, useState } from "react";
import { ScheduleCard } from "../components/ScheduleCard";
import plane from "../assets/img/archivePic3.png";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import "../components/asd.css";
import { Data } from "../Location";
import { GetTravelDataAll } from "../Location";
import Map from "../components/Map";
import PriceTable from "../components/PriceTable";

export function PackageDetail() {
    const [page, setPage] = useState([true, false, false, false]);
    const [tData, setTData] = useState(null);
    const [map, setMap] = useState(<></>);
    const [images, setImages] = useState([
        { original: plane, thumbnail: plane },
    ]);
    const [imgs, setI] = useState([]);
    const [backgroud, setBackground] = useState(w1);
    function ChangePage(page) {
        const p = [false, false, false, false, false];
        p[page] = true;
        setPage(p);
        switch (page) {
            case 0:
                setBackground(w1);
                break;
            case 1:
                setBackground(w2);
                break;
            case 2:
                setBackground(w3);
                break;
            case 3:
                setBackground(w4);
                break;
            case 4:
                setBackground(w4);
                break;
        }
    }
    const [data, setData] = useState(null);
    useEffect(() => {
        Data().then((r) => {
            setData(r);
        });
        const searchParams = new URLSearchParams(window.location.search);
        let num = searchParams.get("num");
        GetTravelDataAll().then((travelData) => {
            if (num >= travelData.length) {
                window.location.href = "/";
                return;
            }
            const img = [];
            for (let i in travelData[num].sceduleImg) {
                img.push(travelData[num].sceduleImg[i]);
            }
            setTData(travelData[num]);
            console.log(travelData);
            const im = [];
            travelData[num].galery.map((i) => {
                im.push({ original: i, thumbnail: i });
            });

            img.push(plane);
            setI(img);
            setImages(im);
            ChangePage(2);
            setMap(<Map center={travelData[num].detail.map.coordinate} />);
            setTimeout(() => {
                ChangePage(0);
            }, 1);
        });
    }, []);
    if (tData == null)
        return (
            <div>
                <div className="page">
                    <img className="pageBackground" src={backgroud} />
                    <div className="pageTop">
                        <div className="archiveTitle1">EXPLORE</div>
                        <div className="archiveTitle2">Landscapes</div>
                    </div>
                    <div className="pageContent1">
                        <div className="detailPageContent">
                            <div className="detailContent">
                                <div className="btns">
                                    <div
                                        className={
                                            "btn" + (page[0] ? " active" : "")
                                        }
                                    >
                                        <img src={info} />
                                        {data ? data.archiveDetail.info : ""}
                                    </div>
                                    <div
                                        className={
                                            "btn" + (page[1] ? " active" : "")
                                        }
                                    >
                                        <img src={cal} />
                                        {data
                                            ? data.archiveDetail.schedule
                                            : ""}
                                    </div>
                                    <div
                                        className={
                                            "btn" + (page[2] ? " active" : "")
                                        }
                                    >
                                        <img src={location} />
                                        {data ? data.archiveDetail.map : ""}
                                    </div>
                                    <div
                                        className={
                                            "btn" + (page[3] ? " active" : "")
                                        }
                                    >
                                        <img src={picture} />
                                        {data ? data.archiveDetail.gallery : ""}
                                    </div>
                                    <div
                                        className={
                                            "btn" + (page[4] ? " active" : "")
                                        }
                                    >
                                        <img src={price} />
                                        {data ? data.price : ""}
                                    </div>
                                </div>
                                <div className="detailMain">
                                    <div
                                        className="detailInner"
                                        style={{
                                            display: page[0] ? "flex" : "none",
                                        }}
                                    >
                                        <div className="detailInner1Name"></div>
                                        <div className="detailInner1Review">
                                            <div className="star"></div>
                                        </div>
                                        <div className="detailInner1Text"></div>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <table>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner"></td>
                                            </tr>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner"></td>
                                            </tr>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner"></td>
                                            </tr>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner"></td>
                                            </tr>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner"></td>
                                            </tr>
                                            <tr>
                                                <td className="title"></td>
                                                <td className="inner included"></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    return (
        <div>
            <div className="page">
                <img className="pageBackground" src={backgroud} />
                <div className="pageTop">
                    <div className="archiveTitle1">EXPLORE</div>
                    <div className="archiveTitle2">Landscapes</div>
                </div>
                <div className="pageContent1">
                    <div className="detailPageContent">
                        <div className="detailContent">
                            <div className="btns">
                                <div
                                    className={
                                        "btn" + (page[0] ? " active" : "")
                                    }
                                    onClick={() => {
                                        ChangePage(0);
                                    }}
                                >
                                    <img src={info} />
                                    {data ? data.archiveDetail.info : ""}
                                </div>
                                <div
                                    className={
                                        "btn" + (page[1] ? " active" : "")
                                    }
                                    onClick={() => {
                                        ChangePage(1);
                                    }}
                                >
                                    <img src={cal} />
                                    {data ? data.archiveDetail.schedule : ""}
                                </div>
                                <div
                                    className={
                                        "btn" + (page[2] ? " active" : "")
                                    }
                                    onClick={() => {
                                        ChangePage(2);
                                    }}
                                >
                                    <img src={location} />
                                    {data ? data.archiveDetail.map : ""}
                                </div>
                                <div
                                    className={
                                        "btn" + (page[3] ? " active" : "")
                                    }
                                    onClick={() => {
                                        ChangePage(3);
                                    }}
                                >
                                    <img src={picture} />
                                    {data ? data.archiveDetail.gallery : ""}
                                </div>
                                <div
                                    className={
                                        "btn" + (page[4] ? " active" : "")
                                    }
                                    onClick={() => {
                                        ChangePage(4);
                                    }}
                                >
                                    <img src={price} />
                                    {data ? data.price : ""}
                                </div>
                            </div>
                            <div className="detailMain">
                                <div
                                    className="detailInner"
                                    style={{
                                        display: page[0] ? "flex" : "none",
                                    }}
                                >
                                    <div className="detailInner1Name">
                                        <div className="a1">
                                            {tData.detail.shortDescription}
                                        </div>
                                    </div>
                                    <div className="detailInner1Review">
                                        <div className="star">
                                            &#9733;&#9733;&#9733;&#9733;&#9733;
                                        </div>
                                        <div className="rev">
                                            ({tData.detail.star})
                                        </div>
                                    </div>
                                    <div className="detailInner1Text">
                                        {tData.detail.longDescription}
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <table>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .location
                                                    : ""}
                                            </td>
                                            <td className="inner">
                                                {tData.detail.location}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .start
                                                    : ""}
                                            </td>
                                            <td className="inner">
                                                {tData.detail.startDate}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .time
                                                    : ""}
                                            </td>
                                            <td className="inner">
                                                {tData.detail.endDate}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .hotel
                                                    : ""}
                                            </td>
                                            <td className="inner">
                                                {tData.detail.hotel}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .commander
                                                    : ""}
                                            </td>
                                            <td className="inner">
                                                {tData.detail.commander}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="title">
                                                {data
                                                    ? data.archiveDetail.table
                                                          .include
                                                    : ""}
                                            </td>
                                            <td className="inner included">
                                                {tData.detail.included.map(
                                                    (i) => {
                                                        return (
                                                            <div className="txt">
                                                                &#9745; {i}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                                {/* <div>
                                                    &#9746; Gallery Ticket{" "}
                                                </div>
                                                <div>&#9745; Lunch</div> */}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div
                                    className="detailInner"
                                    style={{
                                        display: page[1] ? "flex" : "none",
                                    }}
                                >
                                    <div className="detailInner2Text">
                                        {data && data.archiveDetail.schedule}
                                    </div>
                                    {tData.detail.schedule.map((i, index) => {
                                        return (
                                            <ScheduleCard
                                                title={i.title}
                                                text={i.text}
                                                data={i.datas}
                                                num={"0" + (index + 1)}
                                                end={false}
                                                img={imgs[index]}
                                            ></ScheduleCard>
                                        );
                                    })}

                                    {/* <img className="planeImg" src={plane} /> */}
                                </div>
                                <div
                                    className="detailInner"
                                    style={{
                                        display: page[2] ? "flex" : "none",
                                    }}
                                >
                                    <div className="detailInner3Title">
                                        {data && data.archiveDetail.map}
                                    </div>
                                    <div className="detailInner3Text">
                                        {tData.detail.map.texts}
                                    </div>
                                    {map}
                                </div>
                                <div
                                    className="detailInner"
                                    style={{
                                        display: page[3] ? "flex" : "none",
                                    }}
                                >
                                    <ImageGallery
                                        items={images}
                                        additionalClass="imga"
                                    />
                                </div>
                                <div
                                    className="detailInner"
                                    style={{
                                        display: page[4] ? "flex" : "none",
                                    }}
                                >
                                    <PriceTable data={tData.detail.price}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
